import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { ValidDataService } from '../service/validDataService';

// Shape: { encounters: [], refresh: fn, loading: bool, error: any }
const EncountersContext = createContext(null);

export function EncountersProvider({ children }) {
  const [encounters, setEncounters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loadedAt, setLoadedAt] = useState(null);

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res = await ValidDataService.getValidEncounterData();
      if (res?.code === 0 && Array.isArray(res.data)) {
        setEncounters(res.data);
        setLoadedAt(Date.now());
      } else {
        throw new Error('Failed to load encounters');
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = {
    encounters,
    loading,
    error,
    refresh: load,
    loadedAt
  };
  return <EncountersContext.Provider value={value}>{children}</EncountersContext.Provider>;
}

export function useEncounters() {
  const ctx = useContext(EncountersContext);
  if (!ctx) throw new Error('useEncounters must be used within EncountersProvider');
  return ctx;
}
